exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container-fluid[data-v-e3ae52a2] {\n  margin-left: 0;\n  margin-right: 0;\n  padding-left: 0;\n  padding-right: 0;\n  box-sizing: border-box;\n}\nform[data-v-e3ae52a2] {\n  padding: 6px 15px 6px;\n  background-color: #008261;\n  color: white;\n}\n.description[data-v-e3ae52a2] {\n  line-height: 40px;\n}\n.submitBlock[data-v-e3ae52a2] {\n  text-align: center;\n}\n.newsletterBlock input[type=\"email\"][data-v-e3ae52a2] {\n  color: white !important;\n}\n.newsletterBlock input[type=\"email\"][data-v-e3ae52a2]::-webkit-input-placeholder {\n  color: white !important;\n}\n.newsletterBlock input[type=\"email\"][data-v-e3ae52a2]:-ms-input-placeholder {\n  color: white !important;\n}\n.newsletterBlock input[type=\"email\"][data-v-e3ae52a2]::placeholder {\n  color: white !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e3ae52a2","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home/Newsletter.vue
// module id = 675
// module chunks = 3